<template>
  <div v-if="bankData !==null" class="w-full bg-white pb-16 tab-content mt-6">
    <div class="font-medium text-lg px-4 py-8 mb-4 border-b flex items-center justify-between  w-100 border-b">
      <h2>{{ $t('message.selfService.infoEmployee.bankInfo.bank') }}</h2>
    </div>
   <div class="px-4" >
      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            
            name="nameBank"
            class="w-full"
            v-model="bankData.name_bank"
            :label="$t('message.selfService.infoEmployee.bankInfo.nameBank')"
            color="primary"
            outlined
            data-vs-input="nameBank"
            readonly
          />
        </div>
        <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            color="primary"
            outlined
            name="cbu"
            class="w-full"
            v-model="bankData.cbu"
            :label="$t('message.selfService.infoEmployee.bankInfo.cbu')"
            data-vs-input="cbu"
            readonly
          />
        </div>
      </div>
      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full md:w-1/2 mt-10 mr-4 custom-input relative ">
          <zt-input
           outlined
            name="typeAccount"
            class="w-full"
            v-model="bankData.account_type"
            readonly
            :label="$t('message.selfService.infoEmployee.bankInfo.bankAccountType')"
            data-vs-input="typeAccount"
          />
        </div>
        <div class="w-full md:w-full md:w-1/2 px-2 mt-4"></div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="w-full md:w-2/3 m-6 py-6">
      <zt-alert color="info" filled :closeIcon="false">
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
            <p>{{ $t('message.selfService.infoEmployee.tab.emptyTab') }}</p>
          </div>
        </template>
      </zt-alert>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserBankInfo',
 props: {
    bankData: { type: Object }
  },
}
</script>

<style scoped lang="scss">
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>
